import React from 'react';
import { motion } from 'framer-motion';
import banner2 from '../assets/banner2.png';
import kidBg from "../assets/bgcloud.png";
import bonds1 from "../assets/bonds1.png";
import fixedincome from "../assets/bonds-fi.png"
import bondswhy from "../assets/bonds-why.jpg"
import regulatoryImg from "../assets/bonds-regulatory.png"
import faqBg from '../assets/faq.png'; 
import bondsinv from "../assets/bonds1.jpg";
const Bonds = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* SECTION 1: WHAT IT IS (Image Left, Text Right) */}
        <section
  className="relative py-16 md:py-24 text-center overflow-hidden"
  style={{
    backgroundImage: `url(${banner2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  

  <h3 className="relative z-10 font-syne text-[24px] md:text-[32px] text-slate-900 tracking-tight font-medium">
            Bonds
        </h3>
  <div
    className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
    style={{
      background:
        "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
    }}
  />
</section>

 <section className="relative pt-12 pb-4 overflow-hidden bg-white">
        {/* Background Decor - Restored width for symmetry */}
        <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-50 -z-10 hidden lg:block" />

        <div className="max-w-7xl mx-auto px-6 lg:px-24">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-15">
            
            {/* LEFT SIDE: CONTENT */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="w-full lg:w-3/5" // Takes up 60% of the space
            >
              
            
              <div className="space-y-6 max-w-xl"> {/* Prevents text from leaking into the center */}
                <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                 Bonds are fixed-income instruments through which governments, banks, and companies raise capital.
                </p>
                
                <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                 They offer predictable interest payouts, capital stability, and diversification, making them suitable for conservative to moderate-risk investors.
                </p>

                <p className="text-slate-500 text-base md:text-lg font-medium border-l-4 border-red-600 pl-6 py-2 mt-8 italic">
                  Bonds offer steady income, lower volatility, portfolio diversification, and transparent regulation — making them essential for balanced wealth planning.
                </p>
              </div>
            </motion.div>

            {/* RIGHT SIDE: IMAGE */}
            <motion.div 
              className="w-full lg:w-2/5 flex justify-end lg:mt-12" // Takes up 40% and pins to the right margin
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="relative w-full max-w-[450px]"> 
                <div className="overflow-hidden rounded-sm"> {/* Clean edge like Our Story */}
                  <img 
                    src={bonds1} 
                    alt="Mutual Funds Overview" 
                    className="w-full h-auto object-cover aspect-[4/3]"
                  />
                </div>
              </div>
            </motion.div>

          </div>
        </div>
      </section>

   {/* SECTION 2: WHY INVEST IN BONDS (Mirroring MF Benefits Grid) */}
{/* SECTION 3: TYPES OF BONDS 
<section 
  className="relative w-full pt-20 pb-28 overflow-hidden"
  style={{ 
    backgroundImage: `url(${kidBg})`, 
    backgroundSize: 'cover', 
    backgroundPosition: 'center' 
  }}
>
  <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-24">
    
    <div className="text-center mb-12">
      <h3 className="text-[24px] md:text-[40px] text-slate-900 tracking-tight font-medium mb-6">
        Types of Bonds
      </h3>
      <p className="text-slate-600 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto">
        Explore a diverse range of fixed-income instruments, from government-backed security to high-yield corporate debt.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {[
        {
          title: "Government Securities (G-Secs)",
          desc: "Issued by the Government of India; considered the safest. Examples: Treasury Bills, Dated Securities.",
          icon: <ShieldCheck size={24} className="text-red-600" strokeWidth={1.5} />
        },
        {
          title: "State Development Loans (SDLs)",
          desc: "Issued by state governments with slightly higher yields than G-Secs.",
          icon: <Landmark size={24} className="text-red-600" strokeWidth={1.5} />
        },
        {
          title: "Corporate Bonds",
          desc: "Issued by companies to fund operations or expansion. Available across credit ratings — AAA to lower-rated high-yield bonds.",
          icon: <Building2 size={24} className="text-red-600" strokeWidth={1.5} />
        },
        {
          title: "Tax-Free Bonds",
          desc: "Issued by government-backed entities (NHAI, PFC, IRFC) where interest is exempt under Section 10(15).",
          icon: <Percent size={24} className="text-red-600" strokeWidth={1.5} />
        },
        {
          title: "Sovereign Gold Bonds (SGBs)",
          desc: "Government-issued bonds linked to gold prices, offering interest + capital appreciation.",
          icon: <Coins size={24} className="text-red-600" strokeWidth={1.5} />
        },
        {
          title: "Perpetual & AT1 Bonds",
          desc: "High-yield bank instruments with no fixed maturity; carry higher risk.",
          icon: <Activity size={24} className="text-red-600" strokeWidth={1.5} />
        }
      ].map((item, index) => (
        <motion.div 
          key={index}
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.1 }}
          className="p-8 rounded-xl bg-white/80 border border-white shadow-sm hover:shadow-md transition-all duration-300"
        >
          
          <div className="flex items-start gap-4 mb-4">
            <div className="flex-shrink-0 mt-1">
              {item.icon}
            </div>
            <h4 className="font-syne text-[18px] font-bold text-slate-800 tracking-tight leading-tight">
              {item.title}
            </h4>
          </div>

          <p className="text-slate-500 text-base md:text-lg font-medium pl-10">
            {item.desc}
          </p>
        </motion.div>
      ))}
    </div>
  </div>
</section>
*/}
{/*
<section 
  className="relative w-full pt-20 pb-28 overflow-hidden"
  style={{ 
    backgroundImage: `url(${kidBg})`, 
    backgroundSize: 'cover', 
    backgroundPosition: 'center' 
  }}
>
    
  <div className="absolute bottom-0 left-0 w-full h-20 
    bg-gradient-to-t from-white via-white/50 to-transparent 
    pointer-events-none z-0">
  </div>
  <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-24">
    
    <div className="text-center mb-12">
      <h3 className="text-[24px] md:text-[40px] text-slate-900 tracking-tight font-medium mb-6">
        Types of Bonds
      </h3>
      <p className="text-slate-600 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto">
        Explore a diverse range of fixed-income instruments, from government-backed security to high-yield corporate debt.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"> 
      {[
        {
          title: "Government Securities (G-Secs)",
          desc: "Issued by the Government of India; considered the safest. Examples: Treasury Bills, Dated Securities.",
          icon: <ShieldCheck size={22} className="text-red-600" strokeWidth={1.5} />
        },
        {
          title: "State Development Loans (SDLs)",
          desc: "Issued by state governments with slightly higher yields than G-Secs.",
          icon: <Landmark size={22} className="text-red-600" strokeWidth={1.5} />
        },
        {
          title: "Corporate Bonds",
          desc: "Issued by companies to fund operations. Available across ratings — AAA to high-yield.",
          icon: <Building2 size={22} className="text-red-600" strokeWidth={1.5} />
        },
        {
          title: "Tax-Free Bonds",
          desc: "Issued by PSU entities like NHAI/PFC where interest is exempt under Section 10(15).",
          icon: <Percent size={22} className="text-red-600" strokeWidth={1.5} />
        },
        {
          title: "Sovereign Gold Bonds (SGBs)",
          desc: "Linked to gold prices, offering annual interest plus potential capital appreciation.",
          icon: <Coins size={22} className="text-red-600" strokeWidth={1.5} />
        },
        {
         
          title: "Perpetual & AT1 Bonds",
          desc: "High-yield bank instruments with no fixed maturity; carry higher risk profiles.",
          icon: <Activity size={22} className="text-red-600" strokeWidth={1.5} />
        }
      ].map((item, index) => (
        <motion.div 
          key={index}
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.1 }}
          className="p-6 rounded-xl bg-white/85 border border-white/50 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col justify-between"
        >
          <div>
            <div className="flex items-start gap-3 mb-3"> 
              <div className="flex-shrink-0 mt-0.5">
                {item.icon}
              </div>
              <h4 className="font-syne text-[17px] font-bold text-slate-800 tracking-tight leading-tight">
                {item.title}
              </h4>
            </div>

            <p className="text-slate-500 text-[14px] md:text-[15px] font-medium pl-8 leading-snug">
              {item.desc}
            </p>
          </div>
        </motion.div>
      ))}
    </div>
  </div>
</section>
*/}

{/* 
<section className="py-24 bg-white">
  <div className="max-w-7xl mx-auto px-6 lg:px-24">
    <div className="flex flex-col xl:flex-row gap-16">
      
      
      <div className="xl:w-1/4">
        <div className="sticky top-24">
          <h3 className="text-[24px] md:text-[40px] text-slate-900 tracking-tight font-medium mb-6 leading-[1.1]">
            Regulatory <br /> Framework
          </h3>
          <div className="w-12 h-1 bg-red-600 mb-6"></div>
          <p className="text-slate-500 text-lg leading-relaxed font-medium">
            A robust multi-layered oversight system governed by India's apex financial institutions.
          </p>
        </div>
      </div>

      
      <div className="xl:w-3/4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-slate-100 border border-slate-100 rounded-2xl overflow-hidden shadow-sm">
          
          {[
            {
              title: "SEBI Regulations, 2008",
              subtitle: "Issue & Listing Standards",
              desc: "Governs the disclosure, listing, and issuance protocols for debt securities to ensure secondary market transparency."
            },
            {
              title: "RBI Oversight",
              subtitle: "Banking & Sovereign Debt",
              desc: "Regulates G-Secs, SGBs, and bank-issued bonds (including AT1) to maintain systemic financial stability."
            },
            {
              title: "Credit Rating Agencies",
              subtitle: "Mandatory Quality Check",
              desc: "Every corporate bond must be evaluated by SEBI-regulated agencies to assign independent credit risk ratings."
            },
            {
              title: "KYC & Suitability",
              subtitle: "Investor Protection",
              desc: "Strict mandatory norms that verify investor identity and ensure bond products align with risk profiles."
            },
            {
              title: "Risk Disclosures",
              subtitle: "Legal Accountability",
              desc: "Issuers are legally bound to provide comprehensive data on credit, interest rate, and liquidity risks."
            },
            {
              title: "FPI & FDI Limits",
              subtitle: "Capital Flow Regulation",
              desc: "Regulated investment ceilings ensure balanced foreign participation in the domestic debt markets."
            }
          ].map((item, idx) => (
            <motion.div 
              key={idx}
              whileHover={{ backgroundColor: "#f8fafc" }} // Subtle Slate-50 on hover
              className="bg-white p-10 flex flex-col justify-between transition-colors duration-300"
            >
              <div>
                <span className="text-red-600 text-[10px] font-bold tracking-[0.2em] uppercase block mb-4">
                   {item.subtitle}
                </span>
                <h4 className="text-xl font-bold text-slate-900 mb-4 font-syne group-hover:text-red-700">
                  {item.title}
                </h4>
                <p className="text-slate-600 text-base leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

    </div>
  </div>
</section>
*/}
<section className=" pb-4  bg-white relative overflow-hidden pr-24">
  <div className="max-w-7xl mx-auto px-6 lg:px-24 relative z-10">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
      
      {/* LEFT: Content & Elite Geometric Bullets */}
      <div className="lg:translate-x-14">
        
         <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
       Regulatory Framework
      </h3>
         {/*
        <p className="text-slate-600 text-lg md:text-xl leading-relaxed mb-12 ">
          Investable bonds in India are governed by a multi-layered regulatory structure designed to ensure <span className="text-slate-900 font-bold">market integrity</span> and investor security.
        </p> */}

        {/* ELITE BULLET LIST  */}
        <div className="flex flex-col">
          {[
            { 
              title: "SEBI Debt Regulations", 
              detail: "Governed by SEBI (Issue and Listing of Debt Securities) Regulations, 2008 for strict disclosure standards." 
            },
            { 
              title: "RBI Oversight", 
              detail: "The Reserve Bank of India regulates Government Securities, SGBs, and bank-issued AT1 bonds." 
            },
            { 
              title: "Credit Rating Mandate", 
              detail: "Mandatory ratings by SEBI-regulated agencies are required for corporate bonds to signal creditworthiness." 
            },
            { 
              title: "Investor Safeguards", 
              detail: "Strict KYC, Suitability Norms, and mandatory disclosure of Credit, Interest Rate, and Liquidity risks." 
            }
          ].map((item, idx, array) => (
            <div key={idx} className="flex gap-6 group">
              <div className="flex flex-col items-center">
                <div className="w-2.5 h-2.5 bg-white border-2 border-red-600 rotate-45 group-hover:bg-red-600 transition-all duration-300 z-10 relative mt-[7px]"></div>
                {idx !== array.length - 1 && (
                  <div className="flex-grow w-[1px] bg-slate-400 group-hover:bg-red-600/60 transition-colors my-2"></div>
                )}
              </div>
              
              <div className={`${idx !== array.length - 1 ? 'pb-10' : 'pb-0'}`}>
                <h4 className="font-syne text-xl font-bold text-slate-900">
                  {item.title}
                </h4>
                <p className="text-slate-600 text-base md:text-lg font-medium">
                  {item.detail}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* RIGHT: Simple Image (No Card/Border) */}
      <div className="flex flex-col items-center lg:items-end justify-center">

        {/* ✅ ADD THIS ABOVE THE IMAGE */}
  <p className="text-slate-500 text-base md:text-lg font-medium border-l-4 border-red-600 pl-6 italic max-w-md lg:translate-x-16 mt-36">
    Investable bonds in India are governed by a multi-layered regulatory structure designed to ensure{" "}
    <span className="text-slate-900 font-bold">market integrity</span> and investor security.
  </p>

        {/* THE FIX: No border, no card, contain used to prevent cropping */}
        <img 
          src={regulatoryImg} 
          alt="Bond Regulatory Framework" 
          className="w-full h-[400px] md:h-[500px] object-contain lg:translate-x-16 -translate-y-8"
        />
        
        {/* Text centered under the image to match image width
        <div className="text-center w-full">
           <h4 className="text-slate-900 font-syne font-bold text-lg">SEBI & RBI Compliant</h4>
           <p className="text-slate-400 text-[10px] uppercase tracking-[0.2em] font-bold mt-1">
             Institutional Grade Security
           </p>
        </div>
         */}
      </div>

    </div>
  </div>
</section>

 <section
  className="py-10 md:py-14 text-center relative overflow-hidden "
  style={{
    backgroundImage: `url(${faqBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  {/* Shorter, more aggressive fade to keep the image original below the top edge */}
  <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-white via-white/20 to-transparent pointer-events-none z-0"></div>
 {/* BOTTOM FADE: Very short & aggressive to remove the sharp bottom edge only */}
  <div className="absolute bottom-0 left-0 w-full h-10 bg-gradient-to-t from-white via-white/20 to-transparent pointer-events-none z-0"></div>
  <div className="relative z-10 px-6">
   
     <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">Why Invest in Bonds</h2>

    <p className="mt-4 text-base md:text-lg text-slate-600  font-medium max-w-2xl mx-auto">
      Bonds offer steady income, lower volatility, portfolio diversification, and transparent regulation — making them essential for balanced wealth planning.
          </p>
  </div>
</section>
{/*
    <section className="py-24 bg-white overflow-hidden">
  <div className="max-w-7xl mx-auto px-6 lg:px-24">
    <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24 mb-16">
      
      
      <motion.div 
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="w-full lg:w-3/5"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10">
          
          <div className="group">
            <h4 className="text-slate-900 text-xl font-semibold mb-3 flex items-center gap-2 transition-colors group-hover:text-red-700">
              <span className="w-1.5 h-6 bg-red-700 rounded-full"></span>
              What It Is
            </h4>
            <p className="text-slate-600 leading-relaxed font-medium">
            Fixed income investments from governments or corporations, paying regular interest and returning principal at maturity.
            </p>
          </div>

         
          <div className="group">
            <h4 className="text-slate-900 text-xl font-semibold mb-3 flex items-center gap-2 transition-colors group-hover:text-red-700">
              <span className="w-1.5 h-6 bg-red-700 rounded-full"></span>
              Why & Who
            </h4>
            <p className="text-slate-600 leading-relaxed font-medium">
             Ideal for steady income, capital preservation, and diversification—perfect for conservative or income focused investors.
            </p>
          </div>

        
          <div className="group md:col-span-2 pt-4 border-t border-slate-100">
            <h4 className="text-slate-900 text-xl font-semibold mb-3 flex items-center gap-2 transition-colors group-hover:text-red-700">
              <span className="w-1.5 h-6 bg-red-700 rounded-full"></span>
              Why Us
            </h4>
            <p className="text-slate-600 text-lg leading-relaxed font-medium max-w-2xl">
             Expert selection, due diligence, and active management to match your goals with safe, rewarding bond opportunities.
            </p>
          </div>
        </div>
      </motion.div>

      
      <motion.div 
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        className="w-full lg:w-3/5 flex justify-center"
      >
        <div className="rounded-xl overflow-hidden shadow-xl border border-slate-50 max-h-[400px]">
          <img 
            src={bonds} 
            alt="PMS Investment Meeting" 
            className="w-full h-full object-contain bg-white" 
          />
        </div>
      </motion.div>
    </div>

   
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="bg-[#434242] rounded-xl px-12 py-4 flex flex-col md:flex-row items-center justify-between"
    >
      <h3 className="text-white text-xl md:text-2xl font-medium tracking-tight">
        For more information
      </h3>
      <div className="flex flex-wrap justify-center gap-4">
        <button className="px-8 py-2.5 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 transition-all text-sm uppercase tracking-wider">
          Read more
        </button>
        <button className="px-8 py-2.5 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 transition-all text-sm uppercase tracking-wider">
          Contact Us
        </button>
      </div>
    </motion.div>
  </div>
</section>
*/}

{/* 
<section className="py-14 bg-white ">
  <div className="max-w-7xl mx-auto px-6 lg:px-24">
    
    
    <div className="flex flex-col md:flex-row md:items-end justify-between mb-6">
      
        
         <h3 className="text-[24px] md:text-[40px] text-slate-900 tracking-tight font-medium mb-6 leading-[1.1]">
           Types of Fixed Income Instruments
          </h3>
   
     
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">

      
      <div className="lg:col-span-8">
        {[
          {
            title: "Government Securities (G-Secs)",
            desc: "Issued by the Government of India and considered the safest fixed income option. Examples: Treasury Bills, Dated Government Securities."
          },
          {
            title: "State Development Loans (SDLs)",
            desc: "Issued by state governments. These carry slightly higher yields than central government securities due to marginally higher risk."
          },
          {
            title: "Corporate Bonds",
            desc: "Issued by companies for funding operations, expansion, or refinancing. Available across the credit spectrum—from AAA-rated to high-yield bonds."
          },
          {
            title: "Tax-Free Bonds",
            desc: "Issued by government-backed entities such as NHAI, PFC, and IRFC. Interest earned is exempt under Section 10(15)."
          },
          {
            title: "Sovereign Gold Bonds (SGBs)",
            desc: "Issued by the Government of India. Returns are linked to gold prices and include a fixed interest component plus potential capital appreciation."
          },
          {
            title: "Perpetual & AT1 Bonds",
            desc: "High-yield instruments issued primarily by banks. They do not have a fixed maturity date and carry higher risk features."
          }
        ].map((item, idx) => (
          <div 
            key={idx} 
            className="group grid grid-cols-1 md:grid-cols-10 py-10 border-t border-slate-100 last:border-b items-start hover:bg-slate-50/50 transition-all duration-300"
          >
           
            <span className="md:col-span-1 text-red-600 font-syne font-bold text-sm pt-1">
              0{idx + 1}
            </span>
            
            
            <div className="md:col-span-4">
              <h4 className="font-syne text-xl md:text-[22px] font-bold text-slate-900 group-hover:text-red-700 transition-colors">
                {item.title}
              </h4>
            </div>
            
            
            <div className="md:col-span-5">
              <p className="text-slate-600 text-base md:text-lg leading-relaxed font-medium">
                {item.desc}
              </p>
            </div>
          </div>
        ))}
      </div>

      
      <div className="lg:col-span-4 lg:self-center">
        <div className="rounded-xl overflow-hidden shadow-sm">
          <img
            src={fixedincome}
            alt="Market Overview"
            className="w-full h-auto object-cover aspect-[3/4]  transition-all duration-1000"
          />
        </div>
        <p className="mt-8 text-slate-400 text-xs font-bold uppercase tracking-[0.2em] leading-relaxed">
          Sovereign & Institutional <br /> Debt Markets
        </p>
      </div>

    </div>
  </div>
</section>
*/}

{/* ================= FIXED INCOME INTRO SECTION ================= */}
<section className="relative pt-16 pb-20 overflow-hidden bg-white">
  {/* Background Decor - Provides that premium "AIF" style feel */}
  <div className="absolute top-0 left-0 w-1/3 h-full bg-slate-50/50 -z-10 hidden lg:block" />

  <div className="max-w-7xl mx-auto px-6 lg:px-24">
    {/* Using flex-row-reverse to keep the zigzag pattern with your previous sections */}
    <div className="flex flex-col lg:flex-row-reverse items-center justify-between gap-12 lg:gap-32">
      
      {/* RIGHT SIDE: CONTENT */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="w-full lg:w-3/5"
      >
       

        <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
       Investable Fixed Income Instruments
      </h3>
      
        <div className="space-y-6 max-w-lg">
          <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
            Fixed income products provide predictable returns through interest payments while helping preserve capital.
          </p>
          
          <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
            Governments, financial institutions, and corporations issue these instruments to raise funds.
          </p>

          <p className="text-slate-500 text-base md:text-lg font-medium border-l-4 border-red-600 pl-6 py-2 mt-10 italic">
           Fixed Income Instruments are ideal for conservative to moderate-risk investors seeking stability, steady cash flows, and diversification.
          </p>
        </div>
      </motion.div>

      {/* LEFT SIDE: IMAGE */}
      <motion.div 
        className="w-full lg:w-2/5 flex justify-start"
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="w-full max-w-[380px]">
          {/* Use a visual that represents 'Stability' or 'Growth' */}
          <img 
            src={bondsinv} 
            alt="Fixed Income Instruments India" 
            className="w-full h-auto object-contain"
          />
        </div>
      </motion.div>

    </div>
  </div>
</section>





<section 
  className="relative w-full pt-16 pb-20 overflow-hidden bg-white"
  style={{ 
    backgroundImage: `url(${kidBg})`, 
    backgroundSize: 'cover', 
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed'
  }}
>

  <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-white via-white/40 to-transparent pointer-events-none z-0"></div>
  
 
  <div className="absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-white via-white/40 to-transparent pointer-events-none z-0"></div>

  <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-24">
    
   
    <div className="text-center mb-8">
     {/* <h3 className="text-[24px] md:text-[36px] text-slate-900 tracking-tight font-medium mb-4 leading-tight font-syne">
        Types of Fixed Income Instruments
      </h3>
      */}
       <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter"> Types of Fixed Income Instruments</h2>

      <p className="text-slate-600 text-lg md:text-xl leading-relaxed -mb-5">
        A multi-layered regulatory structure designed to ensure market integrity and investor security.
      </p>
    </div>

   
  <div className="relative min-h-[600px] flex items-center justify-center">

  {/* CENTER IMAGE */}
  <div className="relative z-20 w-full max-w-[360px]">
    <img 
      src={fixedincome}
      alt="Fixed Income Portfolio"
      className="w-full h-auto drop-shadow-xl"
    />
  </div>

  {/* LEFT SIDE CARDS */}
  <div className="hidden lg:block">

    {[
      { 
        title: "Government Securities", 
        desc: "Safest fixed income option issued by the Govt of India.",
        pos: "left-[5%] top-[5%]",
      },
      { 
        title: "State Development Loans", 
        desc: "Issued by state governments with slightly higher yields.",
        pos: "left-[-4%] top-[40%]",
      },
      { 
        title: "Tax-Free Bonds", 
        desc: "Interest is exempt under Section 10(15) for tax efficiency.",
        pos: "left-[6%] bottom-[5%]",
      },
    ].map((item, index) => (
      <div key={index} className={`absolute ${item.pos}`}>
        <div className="bg-slate-800 text-white p-5 rounded-xl shadow-xl max-w-[260px] relative border border-slate-700">

          {/* RIGHT-FACING POINTER */}
          <div className="absolute top-1/2 -right-2 w-4 h-4 bg-slate-800 rotate-45 -translate-y-1/2"></div>

          <div className="flex items-center gap-2 mb-2">
            <span className="text-red-600 font-bold text-md">
              0{index + 1}
            </span>
            <h4 className="text-[16px] font-bold leading-tight tracking-tight">
              {item.title}
            </h4>
          </div>

          <p className="text-[14px] text-slate-300 leading-snug line-clamp-2">
            {item.desc}
          </p>
        </div>
      </div>
    ))}
  </div>

  {/* RIGHT SIDE CARDS */}
  <div className="hidden lg:block">

    {[
      { 
        title: "Corporate Bonds", 
        desc: "Funding for companies ranging from AAA to high-yield.",
        pos: "right-[5%] top-[5%]",
      },
      { 
        title: "Sovereign Gold Bonds", 
        desc: "Linked to gold prices with a fixed interest component.",
        pos: "right-[-4%] top-[40%]",
      },
      { 
        title: "Perpetual & AT1 Bonds", 
        desc: "High-yield bank tools with loss-absorption features.",
        pos: "right-[6%] bottom-[5%]",
      },
    ].map((item, index) => (
      <div key={index} className={`absolute ${item.pos}`}>
        <div className="bg-slate-800 text-white p-5 rounded-xl shadow-xl max-w-[260px] relative border border-slate-700">

          {/* LEFT-FACING POINTER */}
          <div className="absolute top-1/2 -left-2 w-4 h-4 bg-slate-800 rotate-45 -translate-y-1/2"></div>

          <div className="flex items-center gap-2 mb-2">
            <span className="text-red-600 font-bold text-md">
              0{index + 4}
            </span>
            <h4 className="text-[15px] font-bold tracking-tight">
              {item.title}
            </h4>
          </div>

          <p className="text-[13px] text-slate-300 leading-relaxed">
            {item.desc}
          </p>
        </div>
      </div>
    ))}
  </div>

</div>


  </div>
</section>

{/* SECTION: WHY ALLOCATE TO FIXED INCOME */}
{/* SECTION: WHY ALLOCATE TO FIXED INCOME */}


<section className="pt-20 md:pt-28 pb-20 md:pb-28 bg-white relative overflow-hidden">
  <div className="max-w-7xl mx-auto px-6 lg:px-24 relative z-10">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-28 lg:gap-36 items-center">

      {/* LEFT COLUMN: IMAGE + NEW MINIMALIST QUOTE */}
      <div className="flex flex-col items-center lg:items-start">
        
        {/* THE IMAGE: Kept large and shifted to fix the margin gap */}
        <div className="w-full flex justify-center lg:justify-start lg:translate-x-12">
          <img
            src={bondswhy}
            alt="Fixed income portfolio stability"
            className="w-full h-auto max-w-[520px] object-contain"
          />
        </div>

        {/* REFINED STATEMENT: No red line, uses typography to create impact */}
        <div className="mt-10 lg:translate-x-12 max-w-lg">
          <span className="text-red-600 text-4xl font-serif leading-none select-none">“</span>
          <p className="text-slate-500 text-lg md:text-xl leading-relaxed font-medium italic -mt-4">
            They form the backbone of balanced wealth planning, helping manage risk effectively while generating steady, predictable returns.
          </p>
        </div>
      </div>

      {/* RIGHT COLUMN: TEXT CONTENT (KEEPING AS IS) */}
      <div className="flex flex-col justify-center max-w-xl">
        <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
          Why Allocate to Fixed Income?
        </h3>

        <div className="w-16 h-[3px] bg-red-600 mb-10"></div>

        <p className="text-slate-600 text-lg md:text-xl leading-relaxed mb-6">
          Fixed income products play a pivotal role in a well-constructed portfolio by offering:
        </p>

        {/* POINTS — COMPACT + NUMBERED (Keeping your preferred logic) */}
        <div className="space-y-2">
          {[
            "Predictable and stable income",
            "Lower volatility compared to equities",
            "Capital preservation",
            "Diversification benefits",
            "Transparent and regulated investments",
          ].map((item, idx) => (
            <div key={idx} className="flex items-start gap-4">
              <span className="text-slate-600 text-base md:text-lg font-medium ">
                {idx + 1}.
              </span>
              <p className="text-slate-600 text-base md:text-lg font-medium">
                {item}
              </p>
            </div>
          ))}
        </div>
      </div>

    </div>
  </div>
</section>

    </div>
  );
};

export default Bonds;